import { IconButton } from '@mui/material';
import { grey } from '@mui/material/colors';
import { MdAdd, MdRemove } from '@teamworksdev/icons';

const buttonStyle = {
  border: 1.5,
  borderRadius: 2,
  borderColor: grey[300],
};

export const IncrementIconButton = ({
  disabled,
  onClick,
  isIncrement = true,
}: {
  disabled?: boolean;
  // whether the button is for incrementing or decrementing
  isIncrement?: boolean;
  onClick: () => void;
}) => {
  return (
    <IconButton
      size="small"
      disabled={disabled}
      onClick={onClick}
      sx={buttonStyle}
    >
      {isIncrement ? <MdAdd /> : <MdRemove />}
    </IconButton>
  );
};
